import React from 'react';
import { withStyles } from '@mui/styles';
import { Menu } from '@mui/material';

const StyledMenu = withStyles(theme => ({
  paper: {
    [theme.breakpoints.up('md')]: {
      minWidth: '90px',
    },

    '& .MuiList-padding': {
      padding: 0,
      '& .MuiMenuItem-root': {
        paddingInlineStart: '8px',
        '& .MuiTypography-body1': {
          paddingLeft: '8px',
        },
      },
    },
  },
}))(props => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

export default StyledMenu;
